import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage, validateYupSchema } from "formik";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import * as Yup from "yup";
import "./DeliveryForm.css";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import GeneralApiService from "../../services/generalServices";
import DynamicFormikForm from "./DynamicFormikForm";
import { useDispatch } from "react-redux";
import { setShowMessage } from "../../redux/slices/notificationSlice";
import { FadeLoader } from "react-spinners";

const transformData = (fields) => {
  const groupedData = fields.reduce((acc, field) => {
    const { main_field_name, ...fieldData } = field;

    if (!acc[main_field_name]) {
      acc[main_field_name] = {
        main_field_name: main_field_name,
        fields: [],
      };
    }

    acc[main_field_name].fields.push(fieldData);
    return acc;
  }, {});

  // Convert the object back to an array for easier rendering with FlatList
  return Object.values(groupedData);
};

const NewEnquiryForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const generalServices = new GeneralApiService();
  const { ev_stage, editData } = location?.state;
  const [selectedValue, setSelectedValue] = useState(null);
  const [categoryList, setCategoryList] = useState([]);
  const [optionsData, setOptionsData] = useState({});
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sspOptions, setSspOptions] = useState([]);

  const getCategoryList = async () => {
    try {
      await generalServices.getCategoryList().then((response) => {
        if (response && response.isSuccess) {
          setCategoryList(response.result);

          if (response.result.length > 0) {
          }
        } else {
          setCategoryList([]);
        }
      });
    } catch (error) {
      console.log(error, "Error getting category");
    }
  };

  const getSspList = async () => {
    try {
      const response = await generalServices.getSspList();
      console.log("SSP List Response:", response);
      if (response && response.isSuccess === true) {
        const formatted = response.result.map((item) => ({
          value: item.ssp_id,
          label: item.first_name,
        }));
        console.log("Formatted SSP Options:", formatted);
        setSspOptions(formatted);
        return formatted;
      }
    } catch (error) {
      console.log("Error fetching SSP list", error);
    }
    return [];
  };
  const getFields = async (selectedCategory, sspOptionsOverride = null) => {
    try {
      setLoading(true);

      const response = await generalServices.getCategoryFields(
        selectedCategory
      );

      if (response && response.isSuccess) {
        const updatedData = {
          ...response.data,
          categoryId: selectedCategory,
          sspOptions: sspOptionsOverride ?? sspOptions,
        };

        // EDIT MODE SUPPORT
        if (editData?.id) {
          const customerRes = await generalServices.getCustomerDetail(editData.id);

          if (customerRes.isSuccess) {
            const [rowData] = customerRes.result.customerData;
            updatedData["customerData"] = rowData;
            updatedData["editData"] = editData;
          }
        }

        setOptionsData(updatedData);

        const transformedData = transformData(
          response.result[selectedCategory]
        );

        return transformedData || [];
      }

      return [];
    } catch (error) {
      console.error("Error retrieving fields:", error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await getCategoryList();
      const loadedSspOptions = await getSspList();
      setSelectedValue("2");
      const fields = await getFields("2", loadedSspOptions);
      setFields(fields);
    };
    fetchData();
  }, []);

  useEffect(() => {
    setOptionsData((prev) => ({
      ...prev,
      sspOptions,
    }));
  }, [sspOptions]);

  const formatType = (type) =>
    type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();

  const handleFormSubmit = async (values) => {
    console.log("Form submitted with values:", values);
    values["categoryId"] = selectedValue;
    values["customer_type"] = "enquiry";

    if (!editData) {
      console.log("ADD----->");
      const response = await generalServices.AddData(values);

      if (response && response.isSuccess) {
        setFields([]);
        setSelectedValue(null);
        const formattedType = formatType(ev_stage.type);
        navigate(`/sale/enquiries/${formattedType}`, {
          state: { type: ev_stage.type },
        });
        dispatch(setShowMessage("New enquiry created successfully."));
      } else {
        dispatch(setShowMessage(response.message));
      }
    } else {
      console.log("EDIT----->");
      values["customerId"] = editData.id;
      values["enquiryId"] = editData.enquiry_id;
      await generalServices.updateMultiFormData(values).then((response) => {
        if (response && response.isSuccess) {
          setFields([]);
          setSelectedValue(null);
          const formattedType = formatType(ev_stage.type);
          navigate(`/sale/enquiries/${formattedType}`, {
            state: { type: ev_stage.type },
          });
          dispatch(setShowMessage(response.message));
        }
      });
    }
  };
  return (
    <>
      <Container className="bg-white rounded">
        <Row className="justify-content-md-center">
          <Col md={12}>
            <Formik
              enableReinitialize={true}
              initialValues={{ category: selectedValue }}
              validationSchema={Yup.object().shape({
                category: Yup.string().required("Category is required"),
              })}
            >
              {({ isSubmitting, values, touched, errors, setFieldValue }) => {
                const handleCategoryChange = async (e) => {
                  let value = e.target.value;
                  try {
                    setFieldValue("category", value);
                    setSelectedValue(value);
                    if (value) {
                      const fields = await getFields(value);
                      setFields(fields);
                    }
                  } catch (error) {
                    console.log(error, "Error during category change");
                  }
                };
                return (
                  <Form>
                    <Row className="mb-1">
                      <Col md={12}>
                        <div className="d-flex align-items-center justify-content-between">
                          <label className="m-0 form-label">
                            {editData ? "EDIT" : "ADD"}{" "}
                            {ev_stage.type.charAt(0).toUpperCase() +
                              ev_stage.type.slice(1)}
                          </label>

                          <Button
                            variant="outline-secondary"
                            className="text-muted mt-1"
                            size="small"
                            onClick={() => {
                              navigate(-1);
                            }}
                          >
                            BACK
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <label htmlFor="category" className="form-label">
                          Select Category *
                        </label>
                        <Field
                          as="select"
                          name="category"
                          className="form-control form-select"
                          onChange={(e) => handleCategoryChange(e)}
                        >
                          <option value="" label="Select Category" />
                          {categoryList.map((category) => (
                            <option
                              key={category.value}
                              value={category.value}
                              label={category.label}
                            />
                          ))}
                        </Field>
                        <ErrorMessage
                          name="category"
                          component={({ children }) => (
                            <span
                              style={{ color: "darkred", fontSize: "0.875rem" }}
                            >
                              {children}
                            </span>
                          )}
                        />
                      </Col>
                    </Row>
                    <hr />
                  </Form>
                );
              }}
            </Formik>

            {loading ? (
              <div
                className="container"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <FadeLoader size={10} color="#808b96" />
                <span
                  style={{
                    // marginTop: "10px",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "16px",
                    color: "#808b96",
                  }}
                >
                  Preparing fields...
                </span>
              </div>
            ) : selectedValue ? (
              <DynamicFormikForm
                key={selectedValue}
                fields={fields}
                optionsData={optionsData}
                submitLabel={editData ? "Save Changes" : "Submit"}
                onSubmit={handleFormSubmit}
              />
            ) : (
              <div className="notification-container">
                <div className="icon-wrapper">
                  {/* Replace Iconic with an icon component like FontAwesome or an image */}
                  <i
                    className="fa fa-file-text-o"
                    style={{ fontSize: "120px", color: "#007aff" }}
                  ></i>
                </div>
                <p className="message">Please select category</p>
              </div>
            )}

          </Col>
        </Row>
      </Container>
    </>
  );
};

export default NewEnquiryForm;
